/**
 * Hook for managing welcome modal state
 * Handles showing modal for first-time users and remembering dismissal
 */

import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const WELCOME_MODAL_DISMISSED_KEY = 'welcome_modal_dismissed';

export const useWelcomeModal = () => {
  const { user } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!user) return;

    // Check if user is new (registered today)
    const registrationDate = user.createdAt ? new Date(user.createdAt) : null;
    const today = new Date();
    const isToday = registrationDate && 
      registrationDate.toDateString() === today.toDateString();

    // Check if modal was already dismissed
    const dismissedUsers = JSON.parse(
      localStorage.getItem(WELCOME_MODAL_DISMISSED_KEY) || '[]'
    );
    const wasModalDismissed = dismissedUsers.includes(user.id);

    // Show modal if user registered today and hasn't dismissed it
    if (isToday && !wasModalDismissed) {
      // Small delay to ensure smooth page transition
      const timer = setTimeout(() => {
        setIsModalOpen(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user]);

  const closeModal = () => {
    setIsModalOpen(false);
    
    if (user) {
      // Remember that this user dismissed the modal
      const dismissedUsers = JSON.parse(
        localStorage.getItem(WELCOME_MODAL_DISMISSED_KEY) || '[]'
      );
      
      if (!dismissedUsers.includes(user.id)) {
        dismissedUsers.push(user.id);
        localStorage.setItem(
          WELCOME_MODAL_DISMISSED_KEY, 
          JSON.stringify(dismissedUsers)
        );
      }
    }
  };

  return {
    isModalOpen,
    closeModal,
  };
};